/* tslint:disable */
/* eslint-disable */
export enum AccountStatus {
    Undervalidation = 'UNDERVALIDATION',
    Pending = 'PENDING',
    Active = 'ACTIVE',
    Suspended = 'SUSPENDED',
    Deleted = 'DELETED'
}
